import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';

type Props = {
    view: boolean;
}

const ManageVideosDetail: React.FC<Props> = ({ view }: Props) => {
    return (
        <ManageBooksDetail
            library_category_name={ELibraryCategory.VIDEO}
            view={view}
            menu_name={'จัดการวีดีโอ'}
            menu_name_detail='เพิ่มวีดีโอ'
            menu_name_detail_edit='รายละเอียดวีดีโอ'
            menu_path_name={routeName.e_library.manage_podcast}
        />
    )
}

export default ManageVideosDetail